import React, { PureComponent } from 'react';
import './index.scss';
import SEARCH_LINE from '@ifit/react-icons/dist/icons/SEARCH_LINE';
import CLOSE_CIRCLE_SOLID from '@ifit/react-icons/dist/icons/CLOSE_CIRCLE_SOLID';
import Icon from '@ifit/react-icons/dist/components/icon';
import { getDeviceType } from '../../../../store/device-type';
import classNames from 'classnames';
import { shark80, solidWhite } from '../../../../theme';
import { ThemeContext } from '@ifit/themes/ThemeContext';
import { searchPlaceholderText } from '../../../../i18n/filter-translations';
import FilterToggle from '../filter-toggle';
import SortDropdown from '@ifit/mp-sort-dropdown';
import { getSortBy, getSortOptions } from '../../../../helpers/sorting';
import { getSearchState } from '../../state/search-state';
import { isSearch } from '../../../../helpers/is-search';

export class SearchField extends PureComponent {
  state = {
    clearCount: false,
  };

  static contextType = ThemeContext;

  componentDidMount() {
    getSearchState().onStateChanged(this.searchStateChanged);
    this.searchStateChanged();
  }

  searchStateChanged = () => {
    this.setState({
      options: getSortOptions(Boolean(getSearchState().current?.query)),
      selectedOption: getSearchState().sortIndex,
    });
  };

  componentWillUnmount() {
    getSearchState().offStateChanged(this.searchStateChanged);
  }

  onSortingChanged = sortLabel =>
    getSearchState().changeSort(getSortBy(sortLabel));

  onChange = event => getSearchState().changeQuery(event.target.value);

  onClear = () => {
    getSearchState().changeQuery('');
    this.textInput.focus();
  };

  onKeyDown = event => {
    if (event.keyCode === 13 && getSearchState().dirty) {
      this.props.onSubmit();
      this.textInput.blur();
    }
  };

  render() {
    const deviceType = getDeviceType();
    const { theme } = this.context;
    const iconColor = {
      LIGHT: shark80,
      DARK: solidWhite,
      VAULT: shark80,
    }[theme];

    let searchIcon = null;
    if (
      (this.props.isMobile && !this.props.searchText) ||
      !this.props.isMobile
    ) {
      searchIcon = (
        <label htmlFor="text-search-field">
          <Icon
            icon={SEARCH_LINE}
            className="search-icon"
            size={20}
            color={iconColor}
          />
        </label>
      );
    }

    const searchURI = isSearch();
    const onSearchAndMobile = searchURI && this.props.isMobile;
    const onSearchMobileOrNotMobileOr7Tablet =
      onSearchAndMobile || !this.props.isMobile || this.props.target7InchTablet;

    return (
      <div className="text-search">
        <div className="search-field">
          {searchIcon}
          {this.props.searchText && (
            <button className="search-clear" onClick={this.onClear}>
              <Icon icon={CLOSE_CIRCLE_SOLID} size={16} color={iconColor} />
            </button>
          )}
          <input
            id="text-search-field"
            ref={input => {
              this.textInput = input;
            }}
            type="text"
            className={classNames(
              'text-search-field',
              this.props.searchText ? 'search-query-entered' : '',
            )}
            name="text-search"
            placeholder={searchPlaceholderText()}
            value={this.props.searchText}
            onChange={this.onChange}
            onFocus={this.props.onFocus}
            onBlur={this.props.onBlur}
            onKeyDown={this.onKeyDown}
            autoComplete="off"
            enterkeyhint="search"
          />
        </div>
        <div className="filter-toggle-sortby-container">
          {onSearchMobileOrNotMobileOr7Tablet && (
            <FilterToggle
              toggleFilters={this.props.toggleFilters}
              filterCount={this.props.filterCount}
              filterOpen={this.props.filterOpen}
              isMobile={this.props.isMobile}
              filtersOpen={this.props.filtersOpen}
            />
          )}
          {onSearchAndMobile && (
            <div
              className="sort-by"
              onClick={this.props.filtersOpen ? this.props.toggleFilters : null}
            >
              <SortDropdown
                key={this.state.selectedOption}
                styleRadioContain={this.props.sortStyle}
                radioSort
                deviceType={deviceType}
                options={this.state.options}
                selectedOption={this.state.selectedOption}
                onOptionChanged={this.onSortingChanged}
                styleRadioOptionContainer={this.props.sortContainStyle}
                isSortDropdownOpen={this.props.isSortDropdownOpen}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
